var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "el-core" },
    [
      _vm.onboarding ? _c("onboarding") : _vm._e(),
      _c("div", { staticClass: "el-core__header" }, [_c("app-core-header")], 1),
      _c("section", { staticClass: "el-core__wrapper" }, [
        _c("div", { staticClass: "el-main" }, [
          _c("div", { staticClass: "el-main__content" }, [
            _c(
              "div",
              { staticClass: "el-bounds _narrow eu-mt_5_md" },
              [
                _vm.isTestAccount
                  ? _c(
                      "emd-alert",
                      {
                        staticClass: "eu-mt_0 eu-no-mb eu-mt_5",
                        attrs: {
                          variant: "info",
                          noClose: "",
                          autoclose: false,
                        },
                      },
                      [
                        _c("template", { slot: "content" }, [
                          _c("p", {
                            staticClass: "emd-text _color_info",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("Webapp.Testflag.title")
                              ),
                            },
                          }),
                        ]),
                      ],
                      2
                    )
                  : _vm._e(),
                _c("read-only-alert"),
                _vm.showBreadcrumb && _vm.accountEnabled
                  ? _c(
                      "div",
                      { staticClass: "el-section eu-mt_5" },
                      [_c("emd-breadcrumb")],
                      1
                    )
                  : _vm._e(),
                _vm.showTabBar && _vm.accountEnabled
                  ? _c(
                      "div",
                      { staticClass: "eu-mt_3" },
                      [
                        _c("emd-tabbar", {
                          attrs: { justify: "space-between", bordered: "" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showTabList && _vm.accountEnabled
                  ? _c(
                      "div",
                      { staticClass: "eu-mt_3" },
                      [
                        _vm.isMobile
                          ? _c(
                              "h2",
                              {
                                staticClass:
                                  "emd-text _color_secondary _size_page",
                              },
                              [_vm._v(_vm._s(_vm.mobileTitle.label.value))]
                            )
                          : _c("emd-tab-list", {
                              attrs: {
                                bordered: "",
                                items: _vm.tabListItems,
                                activeItem: _vm.paymentLinkStatus,
                              },
                              on: { changed: _vm.changeActiveItem },
                            }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "transition",
                  { attrs: { name: _vm.transitionName, mode: "out-in" } },
                  [
                    _vm.accountEnabled
                      ? _c("router-view")
                      : _vm.canConfig
                      ? _c("continue-config")
                      : _c("no-access"),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "el-footer" },
                  [
                    _c(
                      "transition",
                      { attrs: { name: "fade", mode: "out-in" } },
                      [_c("emd-footer")],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }